'use strict';

var React = require('react');
var Select = require('react-select');
var ClassNames = require('classnames');
var InvestmentAllocationActions = require('../../actions/InvestmentAllocationActions');
var InvestmentAllocationStore = require('../../stores/InvestmentAllocationStore');

var filterOptionsHandler = function (inputList, filterString) {

    if(!Array.isArray(inputList))
        return inputList;
        
    let options = [];

    try {

        if (typeof filterString !== 'string') {
            throw 'param options/filterString is invalid.';
        }

        if (filterString != '') {
            var menuOuter = document.getElementsByClassName('Select-menu-outer')[0];
            if (filterString.length >= 3) {
                if (menuOuter) {
                    menuOuter.style.display = 'block';
                }
                options = inputList.filter(function (fund) {
                    filterString = filterString.toLowerCase();
                    return fund.name.toLowerCase().indexOf(filterString) > -1 ||
                        fund.code.toLowerCase().indexOf(filterString) > -1 ||
                        (fund.fmsCode != null && fund.fmsCode.toLowerCase().indexOf(filterString) > -1);
                });
            }
            else {
                if (menuOuter) {
                    menuOuter.style.display = 'none';
                }
            }
        }

    }
    catch (err) {
        console.error('InvestmentOptionSearch->filterOptionsHandler()=> Err: ' + err);
    }

    return options;
};
var InvestmentOptionSearch = React.createClass({
    handleChange: function (newValue, selected) {
        InvestmentAllocationActions.addInvestmentOptions([{
            id: selected[0].value,
            name: selected[0].name,
            code: selected[0].code,
            weight: '',
            termDeposit: selected[0].termDeposit,
            fmsCode: selected[0].fmsCode,
            rebatePaymentOption: selected[0].rebatePaymentOption,
            groupSequenceNumber: selected[0].groupSequenceNumber,
            redemptionSequenceNumber: selected[0].redemptionSequenceNumber,
            isFirstRateInvestment: selected[0].isFirstRateInvestment,
            preRetirementIndicator: selected[0].preRetirementIndicator,
            minTimeframe: selected[0].minTimeframe,
            riskLabel: selected[0].riskLabel,
            cashOption: selected[0].cashOption
        }]);
        InvestmentAllocationActions.updateSearchVisible();
        InvestmentAllocationActions.removeSelectedPortfolioList(true, InvestmentAllocationStore.getList(), InvestmentAllocationStore.getFirstRateCashNonAutoRebalancing());
    },
    handlefilterOptions: function (_options, filterString) {
        return filterOptionsHandler(this.props.investmentOptionsList, filterString);
    },
    componentDidUpdate: function () {
        if (this.props.isFocused) {
            this.refs.investmentSelect.focus();
        }

    },
    handleBlur: function () {        
        this.props.handleOffFocusedInvestmentSearch(false);
        this.props.toggleIsAdd(true);
    },

    render: function () {
        var option = [];
        return (
            <div className={ ClassNames('investment-option-search', { hidden: !this.props.isSearchVisible }) }>
                <Select name="InvestmentSearch"
                        options={option}
                        placeholder={this.props.placeholderText}
                        onChange={this.handleChange}                        
                        onBlur={this.handleBlur}
                        filterOptions={this.handlefilterOptions}
                        searchable={true}
                        ref="investmentSelect"
                        className="select-input-lg remove-select-arrow"
                        inputProps={{id: 'investment-options-search'}} />
            </div>
		);
    }
});

module.exports = InvestmentOptionSearch;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/InvestmentAllocation/InvestmentOptionSearch.jsx